import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaPhone, FaViber } from "react-icons/fa";

const FloatingContactButton = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCall = () => {
    window.location.href = "tel:+381605809797";
  };

  const handleViber = () => {
    window.open("viber://contact?number=%2B381605809797", "_blank");
  };

  const handleWhatsApp = () => {
    window.open("https://wa.me/381605809797", "_blank");
  };

  return (
    <div className="floating-contact">
      <AnimatePresence>
        {isExpanded && (
          <>
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.8 }}
              transition={{ delay: 0.1, duration: 0.2 }}
              className="contact-option"
              onClick={handleWhatsApp}
            >
              <span className="tooltip">WhatsApp</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="green">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488"/>
              </svg>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.8 }}
              transition={{ delay: 0.05, duration: 0.2 }}
              className="contact-option"
              onClick={handleViber}
            >
              <span className="tooltip">Viber</span>
              {/*<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">*/}
              {/*  <path d="M23.155 13.893c.716-6.027-.344-9.832-2.256-11.553l.001-.001C19.621.92 17.833.17 15.149.07l-.33-.008c-2.654-.043-6.918 1.22-9.652 6.702-1.897 3.736-2.913 7.611-2.095 10.642.547 2.016 1.87 3.308 3.285 3.843 1.058.395 2.172.49 3.133.49.294 0 .58-.014.857-.041.955-.096 1.706-.292 2.304-.598.455-.23.795-.445 1.151-.767.09-.08.192-.158.297-.237.338-.255.72-.545 1.212-.821.57-.321 1.311-.646 2.362-.646h.048c.373 0 .75.038 1.116.115 1.089.228 1.96.712 2.596 1.432.636.72 1.044 1.635 1.198 2.708.108.75.155 1.46.155 2.126 0 .694-.022 1.396-.087 2.094-.054.598-.201 1.192-.43 1.761-.323.8-.847 1.532-1.566 2.159l-.018.017c-.73.626-1.58 1.099-2.531 1.396-.846.259-1.793.392-2.806.392-1.068 0-2.135-.15-3.199-.446-1.062-.297-2.118-.738-3.162-1.316-2.108-1.155-4.048-2.834-5.803-5.025C1.444 17.49.093 14.458.013 11.247c-.08-3.224 1.144-6.374 3.425-9.01C5.7-.415 8.641-1.34 12.048-1.338h.012c3.407 0 6.348.925 8.61 3.015 2.262 2.088 3.372 5.217 2.486 10.216"/>*/}
              {/*</svg>*/}
              <FaViber className="contact-option-icon" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.8 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.8 }}
              transition={{ duration: 0.2 }}
              className="contact-option"
              onClick={handleCall}
            >
              <span className="tooltip">Pozovi</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="green">
                <path d="M20.1 16.2l-4.2-2.3c-.4-.2-.8-.2-1.2 0l-2.4 1.3c-1.2-.8-2.4-2-3.2-3.2l1.3-2.4c.2-.4.2-.8 0-1.2L7.8 3.9C7.3 3.6 6.7 3.6 6.3 3.8L3.5 5.3c-.5.2-.8.8-.8 1.3C2.7 14.7 9.3 21.3 17.4 21.3c.5 0 1.1-.3 1.3-.8l1.5-2.8c.2-.4.2-1-.2-1.3z"/>
              </svg>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      <motion.button
        className="contact-button"
        onClick={() => setIsExpanded(!isExpanded)}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <AnimatePresence mode="wait">
          <motion.span
            key={isExpanded ? "close" : "message"}
            initial={{ opacity: 0, rotate: -180 }}
            animate={{ opacity: 1, rotate: 0 }}
            exit={{ opacity: 0, rotate: 180 }}
            transition={{ duration: 0.2 }}
            className="main-contact-button"
          >
            {isExpanded ? "✕" : <FaPhone/>}
          </motion.span>
        </AnimatePresence>
      </motion.button>

      <style jsx>{`
        .floating-contact {
          position: fixed;
          bottom: 24px;
          right: 24px;
          z-index: 1000;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 16px;
        }
        
        .main-contact-button {
          display: flex;
          justify-content: center;
          align-content: center;
        }
        
        .contact-button {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: linear-gradient(135deg, #c89b3c 0%, #b8860b 100%);
          color: white;
          border: none;
          box-shadow: 0 6px 20px rgba(200, 155, 60, 0.4);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          transition: all 0.3s ease;
        }
        
        .contact-option-icon {
          width: 24px;
          height: 24px;
          color: purple;
        }
        
        .contact-option {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: white;
          color: #c89b3c;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          position: relative;
          transition: all 0.3s ease;
        }
        
        .contact-option:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }
        
        .contact-option:hover .tooltip {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0);
        }
        
        .tooltip {
          position: absolute;
          left: 50%;
          top: -40px;
          transform: translateX(-50%) translateY(10px);
          background: #333;
          color: white;
          padding: 6px 12px;
          border-radius: 4px;
          font-size: 12px;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          pointer-events: none;
        }
        
        .tooltip::after {
          content: '';
          position: absolute;
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 5px solid #333;
        }
        
        @media (max-width: 768px) {
          .floating-contact {
            bottom: 16px;
            right: 16px;
          }
          
          .contact-button {
            width: 48px;
            height: 48px;
            font-size: 20px;
          }
          
          .contact-option {
            width: 48px;
            height: 48px;
          }
          
          .contact-option svg {
            width: 20px;
            height: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default FloatingContactButton;